import { t } from 'locale';

import { localeKeys } from 'enums/localeKeys';

const EnvironmentBanner = () => {
  return (
    <div className="bg-yellow-500 p-2 text-center text-sm text-general-100">
      {t(localeKeys.demoBannerText)}
    </div>
  );
};

export default EnvironmentBanner;
